import React from 'react';
import styled, { css } from 'styled-components';
import mergeClassNames from '../../lib/style-helpers/merge-class-name';
import { FontType, FontSize } from '../../../../config/theme/types/themeTypes';
import { StyledWithChildrenProps } from '../../types/StyledWithChildrenProps';

function H5({
  className,
  children,
  ...props
}: StyledWithChildrenProps) {
  return (
    <Header
      className={mergeClassNames('H5', className)}
      {...props}
    >
      {children}
    </Header>
  );
}

const Header = styled.h5 < StyledWithChildrenProps > `
  ${({ theme }) => css`
    ${theme.font(FontType.Strong, FontSize.H5)}
    ${theme.media.tablet} {
      ${theme.font(FontType.Strong, FontSize.H6)}
    }
  `}
`;

export default H5;
